(() => {
  const init = (root) => {
    root.querySelectorAll('[data-technology-animation]').forEach((box) => {
      if (box.dataset.ready) return;
      box.dataset.ready = 'true';
      const img = box.querySelector('img');
      const button = box.querySelector('button');
      let playing = false;
      const setPlaying = (next) => {
        playing = next;
        img.src = next ? box.dataset.animation : img.dataset.still;
        button.textContent = next ? 'Pause animation' : 'Play animation';
        button.setAttribute('aria-pressed', String(next));
      };
      button.hidden = false;
      button.addEventListener('click', () => setPlaying(!playing));
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        const observer = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) {
            setPlaying(true);
            observer.disconnect();
          }
        });
        observer.observe(box);
      }
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
